import { createAction } from '../../../utils/redux/createAction';

const actionsScope = 'patient-portal/results-details-modal';

export const RESULTS_DETAILS_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const resultsDetailsModalActions = {
  open: createAction(RESULTS_DETAILS_MODAL.OPEN),
  close: createAction(RESULTS_DETAILS_MODAL.CLOSE),
};

const initialState = {
  opened: false,
  entity: {},
  ccdLabTestId: '',
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case RESULTS_DETAILS_MODAL.OPEN: {
      return {
        ...state,
        entity: payload.entity,
        ccdLabTestId: payload.ccdLabTestId,
        opened: true,
      };
    }

    case RESULTS_DETAILS_MODAL.CLOSE: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/results-details-modal.js